import React from 'react';
import { motion } from 'framer-motion';
import projectsData from './projects.json';
import './App.css';

function App() {
  const skills = [
    { icon: 'fa-brands fa-python', name: 'Python' },
    { icon: 'fa-brands fa-html5', name: 'HTML' },
    { icon: 'fa-brands fa-css3-alt', name: 'CSS' },
    { icon: 'fa-brands fa-js-square', name: 'JavaScript' },
    { icon: 'fa-brands fa-react', name: 'React' },
    { icon: 'fa-solid fa-flutter', name: 'Flutter' },
  ];

  const interests = [
    { icon: 'fa-solid fa-brain', name: 'A.I.' },
    { icon: 'fa-solid fa-comment-dots', name: 'NLP' },
    { icon: 'fa-solid fa-microchip', name: 'IoT' },
  ];

  const journey = [
    { year: 'Age 9 (2019)', milestone: 'Started coding with Python, built my first "A.I. Voice Assistant".' },
    { year: 'Age 10 (2021)', milestone: 'Explored web development with HTML and CSS, created a personal site.' },
    { year: 'Age 14 (2024)', milestone: 'A Lot Of New Projects (Refer To "My Projects")' },
    { year: 'Age 15 (2025)', milestone: <>Working On A Startup <a href="https://venditas.in" target="_blank" rel="noopener noreferrer">https://venditas.in/</a></> }
  ];

  
  const fadeInVariants = { hidden: { opacity: 0, y: 50 }, visible: { opacity: 1, y: 0, transition: { duration: 0.8 } } };
  const tiltVariants = { hover: { rotate: 5, scale: 1.05, transition: { duration: 0.3 } } };

  const githubProfile = "https://github.com/Dynamo80"


  return (
    <div className="App">
      <nav className="top-nav">
        <ul>
          <li><a href="#dash">Home</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="#journey">Journey</a></li>
          <li><a href="#projects">Projects</a></li>
          <li><a href="#interest">Interests</a></li>
        </ul>
      </nav>
      <header>
        <section id="dash">
          <motion.p
            id="portfolio"
            variants={fadeInVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="dash-item"
          >
            My Portfolio
          </motion.p>
          <motion.h1
            variants={fadeInVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="dash-item"
          >
            Building The Backend, One Line At A Time
          </motion.h1>
          <motion.h3
            variants={fadeInVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="dash-item"
          >
            Crafting Scalable Solutions With Precision And Code
          </motion.h3>
        </section>
      </header>
      <main>
        <section id="about">
          <motion.h1 variants={fadeInVariants} initial="hidden" whileInView="visible" viewport={{ once: true }}>
            I'm Abin, A 15-Year-Old Full Stack Developer Who Started Coding At Age 9, I specialize in
          </motion.h1>
          <div className="skills">
            {skills.map((skill) => (
              <motion.div
                className="skill"
                key={skill.name}
                variants={tiltVariants}
                whileHover="hover"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                <i className={skill.icon}></i>
                <p>{skill.name}</p>
              </motion.div>
            ))}
          </div>
        </section>
        <section id="journey">
          <motion.h1 variants={fadeInVariants} initial="hidden" whileInView="visible" viewport={{ once: true }}>
            My Coding Journey
          </motion.h1>
          <div className="journey-timeline">
            {journey.map((step) => (
              <motion.div
                className="journey-step"
                key={step.year}
                variants={tiltVariants}
                whileHover="hover"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                <h2>{step.year}</h2>
                <p>{step.milestone}</p>
              </motion.div>
            ))}
          </div>
        </section>
        <section id="projects">
          <motion.h1 variants={fadeInVariants} initial="hidden" whileInView="visible" viewport={{ once: true }}>
            My Projects
          </motion.h1>
          <div className="project-cards">
            {projectsData.map((project) => (
              <motion.div
                className="project-card"
                key={project.title}
                variants={tiltVariants}
                whileHover="hover"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                <h2>{project.title}</h2>
                <p className="description">{project.description}</p>
                <div className="tech-stack">
                  {project.tech.map((tech) => (
                    <span key={tech} className="tech-item">{tech}</span>
                  ))}
                </div>
                <a href={project.github} target='_blank' rel="noopener noreferrer" className='github-link'>
                View On Github </a>
              </motion.div>
            ))}
          </div>
        </section>
        <section id="interest">
          <motion.h1 variants={fadeInVariants} initial="hidden" whileInView="visible" viewport={{ once: true }}>
            I have strong interests in
          </motion.h1>
          <div className="interests">
            {interests.map((interest) => (
              <motion.div
                className="interest"
                key={interest.name}
                variants={tiltVariants}
                whileHover="hover"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                <i className={interest.icon}></i> {interest.name}
              </motion.div>
            ))}
          </div>
        </section>
      </main>
      <footer>
        <p>© 2025 Abin Johnson</p>
        <a href={githubProfile} target='_blank' rel="noopener noreferrer" className='github-profile-link'>
          <i className='fa-brands fa-github'></i> Github
        </a>
      </footer>
    </div>
  );
}

export default App;